import React from 'react';
import { Header } from '../components/Header';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { FolderIcon, FileTextIcon, CalendarIcon } from 'lucide-react';
interface CasesScreenProps {
  onSelectCase: (caseId: string) => void;
  onLogout: () => void;
}
export function CasesScreen({
  onSelectCase,
  onLogout
}: CasesScreenProps) {
  const cases = [{
    id: 'case-1',
    name: 'Smith v. Acme Corp',
    matterNumber: 'MAT-2023-0891',
    documentCount: 2847,
    dateGranted: 'Oct 12, 2023'
  }, {
    id: 'case-2',
    name: 'In re: TechHoldings Merger',
    matterNumber: 'MAT-2023-1102',
    documentCount: 14502,
    dateGranted: 'Nov 05, 2023'
  }, {
    id: 'case-3',
    name: 'State of NY v. Horizon Logistics',
    matterNumber: 'MAT-2024-0045',
    documentCount: 892,
    dateGranted: 'Jan 18, 2024'
  }];
  return <div className="min-h-screen flex flex-col" data-id="element-32">
      <Header onLogout={onLogout} data-id="element-33" />

      <main className="flex-1 p-8 max-w-6xl mx-auto w-full" data-id="element-34">
        <div className="mb-8" data-id="element-35">
          <h1 className="text-3xl font-serif text-white mb-2" data-id="element-36">Your Cases</h1>
          <p className="text-gray-400" data-id="element-37">
            Select a matter to begin document review.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-38">
          {cases.map(c => <Card key={c.id} className="flex flex-col h-full" data-id="element-39">
              <div className="p-6 flex-1" data-id="element-40">
                <div className="flex items-start justify-between mb-4" data-id="element-41">
                  <div className="p-2 bg-navy-lighter rounded-lg" data-id="element-42">
                    <FolderIcon className="w-6 h-6 text-amber" data-id="element-43" />
                  </div>
                  <span className="text-xs font-medium text-gray-500 bg-navy px-2 py-1 rounded" data-id="element-44">
                    {c.matterNumber}
                  </span>
                </div>

                <h2 className="text-xl font-serif text-white mb-4 line-clamp-2" data-id="element-45">
                  {c.name}
                </h2>

                <div className="space-y-3 text-sm text-gray-400" data-id="element-46">
                  <div className="flex items-center" data-id="element-47">
                    <FileTextIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-48" />
                    {c.documentCount.toLocaleString()} documents
                  </div>
                  <div className="flex items-center" data-id="element-49">
                    <CalendarIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-50" />
                    Access granted {c.dateGranted}
                  </div>
                </div>
              </div>

              <div className="p-4 border-t border-navy-lighter bg-navy/50" data-id="element-51">
                <Button fullWidth onClick={() => onSelectCase(c.id)} data-id="element-52">
                  Open Case
                </Button>
              </div>
            </Card>)}
        </div>
      </main>
    </div>;
}